import { lazy } from 'react';
import { authModules } from 'app/auth';
import ABSUtils from '@abs/utils/ABSUtils';
import themesConfig from 'app/configs/themesConfig';

const Employees = lazy(() => import('./Employees'));

const EmployeesConfig = {
	settings: {
		layout: {
			config: {}
		},
		theme: {
			main: ABSUtils.IsDarkMode() ? themesConfig.timeliteDark : themesConfig.timelite,
			navbar: ABSUtils.IsDarkMode() ? themesConfig.timeliteDark : themesConfig.timelite,
		}
	},
	routes: [
		{
			path: '/tl/employees',
			element: <Employees />,
			auth: authModules.tl_default
		}
	]
};

export default EmployeesConfig;
